import { useEffect, useState } from "react";

interface ElementSize {
  width: number;
  height: number;
}

//Get window size
export function useWindowSize(): ElementSize {
  const [windowSize, setWindowSize] = useState<ElementSize>({
    width: globalThis.innerWidth,
    height: globalThis.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: globalThis.innerWidth,
        height: globalThis.innerHeight,
      });
    }

    globalThis.addEventListener("resize", handleResize);
    return () => globalThis.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}
